import { createRouter, createWebHashHistory } from 'vue-router'

export const constantRouterMap = [
  {
    path: '/',
    component: () => import('@/views/pape/index.vue'),
    hidden: true
  },
  {
    path: '/tools',
    component: () => import('@/views/pape/tools.vue'),
    redirect: '/tools/idPrint',
    hidden: true,
    children: [
      {
        path: '',
        component: () => import('@/views/pape/toolBlank.vue'),
        meta: { title: '工具首页' }
      },
      {
        path: 'idPrint',
        component: () => import('@/views/pape/idPrint.vue'),
        meta: { title: 'IDPrint' }
      },
      {
        path: 'toWord',
        component: () => import('@/views/pape/toWord.vue'),
        meta: { title: 'PDF转Word' }
      },
      {
        path: 'faPiao',
        component: () => import('@/views/pape/fapiao.vue'),
        meta: { title: '发票合并' }
      },
      {
        path: 'download',
        component: () => import('@/views/pape/download.vue'),
        meta: { title: 'APP下载' }
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    component: () => import('@/views/errorPage/404.vue'),
    hidden: true
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }

    if (to.hash) {
      return {
        el: to.hash
      }
    }

    return { top: 0 }
  },
  routes: constantRouterMap
})

export default router

export const asyncRouterMap = []
